/**
 * Recursively picks a value from an object using a dot-separated path.
 *
 * @param {ObjectType} obj - The input object from which to pick a value.
 * @param {string} [path] - The dot-separated path to the value to pick.
 * @returns {ObjectType | undefined} The value at the specified path, or the input object if no path is provided, or undefined if the path doesn't exist.
 *
 * @example
 * const obj = { a: { b: { c: 1 } } };
 * pick(obj, 'a.b.c'); // returns 1
 *
 */
type ObjectType = {
  [key: string]: any;
};

const pick = (obj: ObjectType, path?: string): ObjectType | undefined => {
  if (!path) return obj;
  if (!obj) return undefined;

  const properties: string[] = path.split('.');
  return pick(obj[properties.shift() as string], properties.join('.'));
};

export { pick };
